import { CART_ITEM_ADDED_EVENT, CART_UPDATED_EVENT, clearCart } from './cartStore.ts';
import { mountCartLines } from './cartLines.ts';

/** Sidebar mini-cart — s'ouvre au clic sur l'icône panier du header et
 * automatiquement après chaque ajout au panier (voir `CART_ITEM_ADDED_EVENT`).
 * Même schéma que `initNav()` (`client/nav.ts`) pour l'ouverture/fermeture,
 * avec en plus un backdrop cliquable (la sidebar n'est pas plein écran). */
export function initCartSidebar(): void {
  const sidebar = document.getElementById('cart-sidebar');
  const backdrop = document.getElementById('cart-sidebar-backdrop');
  const trigger = document.getElementById('cart-trigger');
  const closeBtn = document.getElementById('cart-sidebar-close');
  const linesEl = document.getElementById('cart-sidebar-lines');
  const emptyEl = document.getElementById('cart-sidebar-empty');
  const contentEl = document.getElementById('cart-sidebar-content');
  const totalEl = document.getElementById('cart-sidebar-total');
  const clearBtn = document.getElementById('cart-sidebar-clear');
  if (!sidebar || !backdrop || !trigger || !closeBtn || !linesEl || !emptyEl || !contentEl || !totalEl || !clearBtn) return;

  function refresh(): void {
    void mountCartLines({ linesEl: linesEl!, emptyEl: emptyEl!, contentEl: contentEl!, totalEl: totalEl! });
  }

  function open(): void {
    sidebar!.classList.add('is-open');
    backdrop!.classList.add('is-open');
    sidebar!.setAttribute('aria-hidden', 'false');
    refresh();
  }

  function close(): void {
    sidebar!.classList.remove('is-open');
    backdrop!.classList.remove('is-open');
    sidebar!.setAttribute('aria-hidden', 'true');
  }

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  });
  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  clearBtn.addEventListener('click', clearCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar!.classList.contains('is-open')) close();
  });

  window.addEventListener(CART_ITEM_ADDED_EVENT, open);
  window.addEventListener(CART_UPDATED_EVENT, () => {
    if (sidebar!.classList.contains('is-open')) refresh();
  });
}
